/**
 * Générateur — Automatisme : donner les carrés des nombres entiers compris
 * entre 0 et 12.
 * Attendu ID : 1220 | Niveau : 3ème | Domaine : Racine carrée
 * Rubrique : AUTOMATISME (programme 2025, cycle 4 page 11, ligne 764 :
 * « Donner les carrés des nombres entiers compris entre 0 et 12. », la
 * ligne de 4e (l. 691) répétée mot pour mot).
 *
 * ── WRAPPER de gen_1105 (donc des clés donner_* de gen_1101) ─────────────
 * Le périmètre est identique (entiers 0..12, sens direct 9 → 81, mise en
 * œuvre Eduscol 2026 p. 17 : la récitation que la racine carrée prend pour
 * socle) et la banque MathsMentales range la 3e sur la même option que la
 * 4e (4NC1 option 1 « Carrés de 1 à 12 (4e, 3e) », 6ND13 option 1, relevé
 * 2026-09-12). Mapping 3e validé par le prof le 2026-09-12 : W de 1105.
 * Payload re-badgé (niveau 3e, attendu 1220) ; coups de pouce et solveurs
 * sont ceux de 1105 (donc de 1101).
 */
import { generate as genererCarres, CATEGORIES as CAT_DONNER } from '../../4eme/puissances/gen_1105';

const ATTENDU_ID = 1220;

export const CATEGORIES = CAT_DONNER;

export const generate = (typeExercice) => {
    const payload = genererCarres(typeExercice);
    payload.niveau = '3eme';
    payload.attendu = ATTENDU_ID;
    return payload;
};
